// ================================
// Active Chat (MongoDB chatId)
// ================================
const ACTIVE_CHAT_KEY = "logicline_active_chat";

export const getActiveChatId = () => {
  return localStorage.getItem(ACTIVE_CHAT_KEY);
};

export const setActiveChatId = (chatId) => {
  localStorage.setItem(ACTIVE_CHAT_KEY, chatId);
};

export const clearActiveChatId = () => {
  localStorage.removeItem(ACTIVE_CHAT_KEY);
};

// ================================
// Auth Token
// ================================
const TOKEN_KEY = "logicline_token";

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
};

export const setToken = (token, remember = true) => {
  if (remember) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    sessionStorage.setItem(TOKEN_KEY, token);
  }
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
};

export const isLoggedIn = () => {
  return !!getToken();
};

// ================================
// User Info
// ================================
const USER_KEY = "logicline_user";

export const getUser = () => {
  const user = localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);
  try {
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
};

export const setUser = (user, remember = true) => {
  const s = JSON.stringify(user);
  if (remember) {
    localStorage.setItem(USER_KEY, s);
  } else {
    sessionStorage.setItem(USER_KEY, s);
  }
};

// ================================
// Full logout (clears UI cache)
// ================================
export const logout = () => {
  clearToken();
  clearActiveChatId();
  localStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(USER_KEY);

  // Remove cached chats + uploads (UI only)
  localStorage.removeItem("logicline_chats");
  Object.keys(localStorage).forEach((k) => {
    if (k.startsWith("logicline_uploads_")) {
      localStorage.removeItem(k);
    }
  });
};
